import { render } from "./StockPartForm.vue?vue&type=template&id=649368c7"
import script from "./StockPartForm.vue?vue&type=script&lang=js"
export * from "./StockPartForm.vue?vue&type=script&lang=js"

import "./StockPartForm.vue?vue&type=style&index=0&id=649368c7&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__